import { render, staticRenderFns } from "./tabBars.vue?vue&type=template&id=de83b99c&scoped=true&"
import script from "./tabBars.vue?vue&type=script&lang=ts&"
export * from "./tabBars.vue?vue&type=script&lang=ts&"
import style0 from "./tabBars.vue?vue&type=style&index=0&id=de83b99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de83b99c",
  null
  
)

export default component.exports